<template>
  <page-block :title="'Логирование'">
    <a-row class="elastic-block__filters" :gutter="10" type="flex">
      <a-col flex="1">
        <input-enum
          v-model="log_type"
          :options="log_types"
          :allowClear="false"
          label="Тип:"
        />
      </a-col>

    </a-row>
    <a-spin :spinning="loading">
      <div class="spin-content">
        <div class="page-block__component">
          <ag-grid-vue
            class="table ag-grid-table"
            :rowHeight="53"
            :headerHeight="53"
            style="width: 100%; max-height: 500px"
            :columnDefs="columnDefs"
            :rowData="rowData"
            :suppressHorizontalScroll="true"
            :unSortIcon="true"
            :pagination="false"
            @grid-ready="onGridReady"
            @rowClicked="cellClick($event)"
          />
        </div>
      </div>
    </a-spin>

    <component-pagination
      :page="page"
      :size="pageSize"
      :total="250000"
      @changePage="page = $event"
      @changeSize="pageSize = $event"
    />


    <a-modal
      width="1170px"
      :visible="showModal"
      :bodyStyle="modalBodyStyle"
      :title="'Загрузка данных'"
      :footer="null"
      :closable="false"
      transitionName="none"
      maskTransitionName="none"
      @cancel="showModal = false"
    >
      <div class="entity-modal">
        <div class="modal" style="padding: 2%">
          <pre v-if="row_data">{{ row_data }}</pre>
        </div>
      </div>
    </a-modal>
  </page-block>
</template>

<script>
import axios from 'axios';
import { AgGridVue } from 'ag-grid-vue';
import store from '@/store';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import PageBlock from '@/components/page/PageBlock.vue';
import testData from './test/data.json';
import TableCell from '@/pages/table/table/TableCell.vue';
import InputEnum from '@/components/base/InputEnum.vue';

export default {
  name: 'LogPage',

  components: {
    PageBlock,
    AgGridVue,
    InputEnum,
    ComponentPagination: () => import('@/components/base/ComponentPagination.vue')
  },

  data() {
    return {
      gridApi: null,
      columnApi: null,
      columnDefs: null,
      rowData: null,
      log_types: ['Пользовательское событие',"Системное событие"],
      log_type: 'Пользовательское событие',
      page: 3253,
      pageSize: 10,
      loading: true,
      defaultColDef: {
        resizable: true,
        cellRendererFramework: 'TableCell'
      },
      showModal: false,
      row_data: ''
    };
  },
  computed: {
    modalBodyStyle() {
      return {
        height: '70vh',
        maxWidth: '1170px',
        width: '100%',
        backgroundColor: '#f9f9f9',
      };
    },
  },
  watch: {
    page() {
      this.refetch(false);
    },
    pageSize() {
      this.refetch();
    },
    log_type(){
      this.refetch(false);
    }
  },

  beforeMount() {
    this.columnDefs = [];

    this.rowData = [];
  },

  methods: {
    async onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
      this.refetch()
    },
    cellClick(event){
      this.row_data = this.fullData.find((el)=>el.id === event.data.id)
      if (this.row_data) this.showModal = true
    },
    async refetch() {
      this.gridApi.hideOverlay();
      this.loading = true
      try {
        const clientId = store.state.user.username;
        const response = await axios.get(`/private/transaction-outbox/write-offset?clientId=${clientId}&offset=${(this.page-1)*this.pageSize}&size=${this.pageSize}`)
        let { data } = await axios.get(`/private/transaction-outbox/next?clientId=${clientId}`);
        data = data.slice(0, this.pageSize)
        this.createTableHeaders(data);
        this.createTableRows(data);
      } catch (error) {
        console.log(error)
        this.createTableHeaders(testData);
        this.createTableRows(testData);
      }
    },
    createTableRows(data) {
      this.rowData = []
      this.fullData = data
      this.rowData = data.map((obj) => {
        const res = {};
        Object.keys(this.columnDefs).forEach((key) => {
          res[this.columnDefs[key].field] = obj[this.columnDefs[key].field];
        });
        return res;
      });
      this.loading = false
    },
    createTableHeaders(data) {
      this.columnDefs = []
      Object.keys(data).forEach((key, i) => {
        const dataInside = data[key];

        if (i === 0) {
          Object.keys(dataInside).forEach((key2) => {
            if (typeof dataInside[key2] !== 'object') {
              if (key2 === 'id') {
                this.columnDefs.push({
                  field: key2,
                  resizable: true,
                  width: 80,
                });
              } else {
                this.columnDefs.push({
                  field: key2,
                  resizable: true,
                  flex: 1,
                });
              }
            }
          });
        }
      });
    },
  },
};
</script>

<style lang="scss">
.stat-page__table {
  @include scrollbars();
  overflow-x: auto;
}

.table {
  @include scrollbars();
  color: $darkTextColor;
  font-size: 13px;

  .tags__item.ant-tag {
    margin-top: 0;
  }

  .tags {
    margin-top: -5px;
  }

  .ag-root-wrapper-body.ag-layout-normal {
    height: auto;
  }

  .ag-header-cell {
    font-weight: 700;
  }

  .ag-cell,
  .ag-header-cell {
    padding: 16px;
    overflow-wrap: break-word;
  }

  td,
  .ag-cell {
    white-space: nowrap;
  }

  &.hasClickableRows {
    tbody tr,
    .ag-row {
      cursor: pointer;
    }
  }

  .ant-table-column-title,
  .ag-header-cell-text {
    white-space: nowrap;
    padding-right: 5px;
  }

  .ant-table-column-sorter-inner {
    display: flex;
    flex-direction: column;
    color: #bfbfbf;

    .anticon {
      color: inherit;
    }
  }

  .sort-asc {
    .anticon-caret-up {
      color: #366dbb;
    }
  }

  .sort-desc {
    .anticon-caret-down {
      color: #366dbb;
    }
  }

  &__text {
    min-height: 1.6em;

    &--short {
      max-width: 50px;
    }
  }

  &__color-field {
    width: 122px;
  }

  &__actions {
    visibility: visible;
    text-align: center;
  }

  &__gallery {
    margin: -20px 0px;
    max-width: 300px;

    img {
      & + img {
        margin-left: 5px;
      }
    }
  }

  .ant-table-placeholder {
    display: none;
  }

  &.ant-table-wrapper,
  &.ag-grid-table {
    @include scrollbars();
    overflow-x: auto;
    border: 1px solid rgba(0, 0, 0, 0.08);
    border-radius: $borderRadius;

    .ag-overlay {
      position: initial;

      .ag-overlay-no-rows-wrapper {
        min-height: 50px;
      }
    }
  }

  // For editable cells
  .ant-form-item {
    margin: 0;
  }

  .ant-form-item-control {
    line-height: 24px;
  }
}

.ag-dnd-ghost {
  border: solid 1px;
  border-color: $defaultBorderColor;
  background: $blockGrayBg;
  border-radius: 3px;
  box-shadow: 0 1px 4px 1px rgba(186, 191, 199, 0.4);
  overflow: hidden;
  text-overflow: ellipsis;
  color: $darkTextColor;
  height: 48px !important;
  line-height: 48px;
  margin: 0;
  padding: 0 12px;
  -webkit-transform: translateY(12px);
  transform: translateY(12px);
}

.ag-dnd-ghost-icon {
  color: $darkTextColor;
}

.table-edit-popover {
  .ant-popover-arrow {
    display: none;
  }

  .ant-form-item {
    margin-bottom: 0;
  }

  .ant-form-item-control {
    line-height: 32px;
  }

  .ant-popover-inner-content {
    padding-right: 2px;
  }
}

.annual_catalog {
  .table .ag-cell {
    &.impCode_2 {
      background: #ffdcdc;
    }

    &.impCode_1 {
      background: #fff6d4;
    }
  }

  .ag-row-hover .ag-cell {
    &.impCode_2 {
      background: darken(#ffdcdc, 10%);
    }

    &.impCode_1 {
      background: darken(#fff6d4, 10%);
    }
  }
}
</style>
